import axios from 'axios';
const headers = {'Accept': 'application/json'};
import Vue from 'vue';
import Router from 'vue-router';
import Login from './views/Login';
import notfound from './views/notfound';
import productPage from './views/productPage';
import checkout from './views/checkout';
import store from './store/index'
import category from './views/category'
import home from './views/home'
import searchView from './views/searchView'
import toc from './views/toc'
import consult from './views/consult'
import maillist from './views/maillist'
import importer from './views/importer'
import Create from './views/ServicePage/Create.vue'
import Edit from './views/ServicePage/Edit.vue';
import Show from './views/ServicePage/Show.vue';
import PurchaseOrderCreate from './views/PurchaseOrder/Create.vue'
import PurchaseOrderEdit from './views/PurchaseOrder/Edit.vue';
import PurchaseOrderDetails from './views/PurchaseOrder/Details.vue';
import WholesaleEdit from './views/Wholesale/Edit.vue';
import WholesaleDetails from './views/Wholesale/Details.vue';
import RegisterFormsEdit from './views/RegisterForms/Edit.vue';

import FormCreate from './views/FormBuilder/Create.vue';
import FormList from './views/FormBuilder/List/Form.vue';
import FormEdit  from './views/FormBuilder/Edit.vue';
import form_submission_result  from './views/FormBuilder/List/FormSubmissionResult.vue';
import Pixel from './views/FormBuilder/List/Pixel.vue';
import addPlan from'./views/Plans/addPlan.vue';
import planList from'./views/Plans/planList.vue';
import editPlan from'./views/Plans/EditPlan.vue';
import planPrice from'./views/Plans/PlanPrice.vue';

import trackorders from './views/trackOrders.vue';
import sellerOrders from'./views/seller_orders.vue';
import adminSellerOrders from './views/admin_seller_orders.vue';
import integrationSentId from './views/integrationSentId.vue';


let menu = store.state.modelMenu
let main = menu.filter(x => !x.subs)
let subs = [].concat(...menu.filter(x => x.subs).map(x => x.subs))
let extra = [
  {text:'checkout', roles:['master','superadmin', 'admin', 'user', "user-agent"]},
  {text:'product', roles:['master','superadmin', 'admin', 'user', "user-agent"]},
  {text:'category', roles:['master','superadmin', 'admin', 'user', "user-agent"]},
  {text:'import', roles:['master','superadmin', 'admin', 'user', "user-agent", "business", "business-master"]},
  {text:'search', roles:['master','superadmin', 'admin', 'user', "user-agent"]},
  {text:'service_pages_create', roles:['master', 'dev', 'admin']},
  {text:'service_pages_edit', roles:['master', 'dev', 'admin']},
  {text:'service_pages_show', roles:['master','superadmin', 'admin', 'dev', 'user', "user-agent", "business", "business-master"]},
  
  {text:'purchase_order_pages_create', roles:['master', 'superadmin','dev', 'admin', 'user', "user-agent", "business", "business-master"]},
  {text:'purchase_order_pages_edit', roles:['master', 'dev', 'admin']},
  {text:'purchase_order_pages_details', roles:['master', 'superadmin','dev', 'user', "user-agent", "business", "business-master"]},

  {text:'wholesale_product_pages_create', roles:['master', 'dev', 'admin', "business", "business-master"]},
  {text:'wholesale_product_pages_edit', roles:['master', 'dev', 'admin', "business", "business-master"]},
  {text:'wholesale_product_pages_details', roles:['master', 'superadmin', 'dev', 'admin', 'user', "user-agent", "business", "business-master"]},

  {text:'register_forms_create', roles:['master', 'dev', 'admin', "business", "business-master"]},
  {text:'register_forms_edit', roles:['master', 'dev', 'admin', "business", "business-master"]},

  {text:'form_create', roles:['master', 'superadmin','dev','user', "business", "business-master"]},
  {text:'form_edit', roles:['master', 'superadmin','dev','user', "business", "business-master"]},
  {text:'form_list', roles:['master', 'superadmin','dev','user', "business", "business-master"]}, 
  {text:'form_submission_list', roles:['master', 'superadmin','dev','user', "business", "business-master"]},   
  {text:'form_submission_result', roles:['master', 'superadmin','dev','user', "business", "business-master"]},

  {text:'pixel', roles:['master', 'superadmin','dev','user', "business", "business-master"]},

  {text:'add_plan', roles:['master', 'superadmin', 'dev']},
  {text:'plan_list', roles:['master', 'superadmin', 'dev']},
  {text:'edit_plan', roles:['master', 'superadmin','dev']},
  {text:'plan_price', roles:['master', 'superadmin','dev','user', "business", "business-master"]},

  {text:'seller_orders', roles:['master','superadmin', 'admin', 'dev', 'user', "user-agent", "business", "business-master"]},
  {text:'admin_seller_orders', roles:['master','superadmin', 'admin', 'dev']},
  {text:'integrationSentId', roles:['master','superadmin', 'admin', 'dev']},



]
let all = main.concat(subs)
let allMapped = all.map(x=>{
  return {
    path: x.path,
    name: x.text,
    component: () => import(`./views/${x.text}`),
  }
})
// console.log('------------------------------------');
// console.log(all);
// console.log('------------------------------------');


const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  },
  beforeRouteUpdate(to, from, next) {
    // react to route changes...
    // don't forget to call next()
    // console.log(to)
    // console.log(from)
    //next()
  },
  routes: [
    {
      path: '/home',
      name: 'home',
      component: home,
    },
    {
      path: '/consult',
      name: 'consult',
      component: consult,
    },
    {
      path: '/search',
      name: 'search',
      component: searchView,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/v/:hash',
      name: 'verify',
      component: Login,
    },
    {
      path: '/toc',
      name: 'toc',
      component: toc,
    },
    {
      path: '/maillist/:hash',
      name: 'maillist',
      component: maillist,
    },
    {
      path: '/register',
      name: 'register',
      component: Login,
    },
    {
      path: '/checkout',
      name: 'checkout',
      component: checkout,
    },
    {
      path: '/product/:cc/:hash',
      name: 'product',
      component: productPage,
    },
    {
      path: '/category/:name',
      name: 'category',
      component: category,
    },
    {
      path: '/import',
      name: 'import',
      component: importer,
    },
    {
      path: '/service-pages/create',
      name: 'service_pages_create',
      component: Create,
    },
    {
      path: '/service-pages/:page/edit',
      name: 'service_pages_edit',
      component: Edit,
    },
    {
      path: '/service-pages/:page',
      name: 'service_pages_show',
      component: Show,
    },
    {
      path: '/purchase-order/create',
      name: 'purchase_order_pages_create',
      component: PurchaseOrderCreate,
    },
    {
      path: '/purchase-order/:page/edit',
      name: 'purchase_order_pages_edit',
      component: PurchaseOrderEdit,
    },
    {
      path: '/purchase-order/:page/details',
      name: 'purchase_order_pages_details',
      component: PurchaseOrderDetails,
    },
    {
      path: '/wholesale-product/create',
      name: 'wholesale_product_pages_create',
      component: WholesaleEdit,
    },
    {
      path: '/wholesale-product/:page/edit',
      name: 'wholesale_product_pages_edit',
      component: WholesaleEdit,
    },
    {
      path: '/wholesale-product/:page/details',
      name: 'wholesale_product_pages_details',
      component: WholesaleDetails,
    },

    {
      path: '/register-forms/create',
      name: 'register_forms_create',
      component: RegisterFormsEdit,
    },
    {
      path: '/register-forms/:page/edit',
      name: 'register_forms_edit',
      component: RegisterFormsEdit,
    },
    {
      path:'/FormBuilder/Create',
      name:'form_create',
      component:FormCreate,
    },
    {
      path:'/FormBuilder/List/Form',
      name:'form_list',
      component:FormList,
    },
    {
      path:'/FormBuilder/Form/Edit/:id',
      name:'form_edit',
      props: true,
      component: FormEdit
    },
    {
      path: '/FormBuilder/List/FormSubmissionResult/:id',
      name: 'form_submission_result',
      props: true,
      component: form_submission_result,

  },
  {
    path: '/FormBuilder/List/Pixel',
    name: 'pixel',
    component: Pixel,
  },

  {
    path: '/Subscription/Plan',
    name: 'add_plan',
    component: addPlan,
  },

  {
    path: '/Subscription/Plan/List',
    name: 'plan_list',
    component: planList,
  },
  {
    path:'/Subscription/Plan/Edit/:id',
    name:'edit_plan',
    props: true,
    component: editPlan
  },

  {
    path: '/Subscription/Plan/Price',
    name: 'plan_price',
    component: planPrice,
  },
     
  
  {
    path: '/trackorders/:document_number',
    name: 'trackorders',
    props: true,
    component: trackorders,

},

{
  path: '/seller/orders',
  name: 'seller_orders',
  component: sellerOrders,

},


{
  path: '/admin/seller/orders',
  name: 'admin_seller_orders',
  component:adminSellerOrders,

},
{
  path: '/admin/integration-sent-id',
  name: 'integrationSentId',
  component:integrationSentId,

},
    {
      // will match everything
      path: '*',
      component: notfound,
    }
  ].concat(allMapped)
})

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

router.beforeEach(async (to, from, next) => {
  
  
  

  let noGate = ['home', 'login', 'register', 'toc', 'verify', 'maillist', 'consult','trackorders']
  
  if(noGate.includes(to.name)) {
    
    next()
  } else {
    var w = window.location.origin
    var base_url = w.includes('localhost') || w.includes('firebase') || w.includes('web.app') || w.includes('ninjasellers.com') ? 'https://yervip.com' : window.location.origin
    if(process.env.VUE_APP_VARS && process.env.VUE_APP_VARS === 'local') {
      base_url = 'http://127.0.0.1:8000'
    }
    store.dispatch('setSettingsBase', {base:base_url})
    let access_token = getCookie('_MJC')
    if(access_token) {
      store.state.access_token = access_token
    }
    let user = await store.dispatch('getUser')
    let a = all.filter(x => x.text == to.name)
    .filter(x => x.roles && x.roles.includes(user.role) || x&&x.roles.includes('affiliate')&&user && user.affiliate)
    let b = extra.filter(x => x.text == to.name)
    .filter(x => x.roles && x.roles.includes(user.role))
    
    if ((a && a.length) || (b && b.length)) {
      console.log('allowed')
      next()
    } else {
      
      next({ name: 'home'})
    }
  } 
  
})


Vue.use(Router);

export default router